var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"CapabilityFolder has-text-grey"},[_c('i',{staticClass:"far fa-folder-open"}),_vm._v("\n       \n  "),_vm._l((_vm.splitPath(_vm.folder)),function(p){return _c('span',{key:p},[_c('span',{staticClass:"has-text-grey-lighter"},[_vm._v("/")]),_vm._v(" "+_vm._s(p)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }